import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { NavbarService } from '../../services/navbar.service';
import { ProgressBarService } from '../../services/progress-bar.service';
import { ThemesService } from '../../services/themes.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  constructor(
    public navbarService: NavbarService,
    public authService: AuthService,
    public progressBarService: ProgressBarService,
    public themesService: ThemesService,
    public router: Router,
  ) {}

  ngOnInit(): void {}
}
